import { preview } from '@/components/form/preview'

import { CheckCircleOutlineOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'

import { useTexts } from '../../hooks/useTexts'

import { FieldPointsContainer } from './FieldPointsContainer'

interface Props {
  companyPhone: string
  showContactPhone: boolean
}

export function CompanyPhone(props: Props) {
  const { companyPhone, showContactPhone } = props

  const texts = useTexts()

  return (
    <preview.Field testId="trackingPage-companyPhone" label={texts.companyPhone}>
      <preview.Value>
        {companyPhone}
        {showContactPhone && (
          <FieldPointsContainer>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <CheckCircleOutlineOutlined
                sx={{ fontSize: '16px', flexShrink: 0 }}
                color="primary"
              />
              <Typography variant="caption" lineHeight={1}>
                {texts.showContactPhone}
              </Typography>
            </Stack>
          </FieldPointsContainer>
        )}
      </preview.Value>
    </preview.Field>
  )
}
